import { AppError } from "../Types/AppError";

/**
 * Build a standardized AppError with a context-specific fallback message.
 */
export function buildAppError(
  error: any,
  userMessage: string,
  technicalMessage?: string
): AppError {
  // Derive technical detail string with robust fallbacks
  let details =
    technicalMessage ||
    (typeof error?.response?.data === "string"
      ? error.response.data
      : error?.response?.data?.message) ||
    error?.response?.data?.detail ||
    error?.message;

  const status = error?.response?.status;
  if (status && details) {
    details = `${details}`;
  }

  return {
    message: userMessage,
    technicalDetails: details,
  };
}
